import React, { useState, useEffect } from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import { Spinner, Alert } from "react-bootstrap";
import api from "../api";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "./StudentCalendar.css";

const localizer = momentLocalizer(moment);

const StudentCalendar = () => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchCalendar = async () => {
      try {
        setLoading(true);
        const response = await api.get("/participations/my-calendar");
        const formattedEvents = response.data.map(event => ({
          ...event,
          start: new Date(event.start),
          end: new Date(event.end)
        }));
        setEvents(formattedEvents);
      } catch (err) {
        console.error("Failed to load calendar", err);
        setError("Unable to load your schedule.");
      } finally {
        setLoading(false);
      }
    };

    fetchCalendar();
  }, []);

  if (loading) {
    return (
      <div className="student-calendar-state">
        <Spinner animation="border" size="sm" /> <span className="ms-2">Loading your schedule…</span>
      </div>
    );
  }

  if (error) {
    return <Alert variant="danger">{error}</Alert>;
  }

  return (
    <div className="student-calendar-wrapper">
      <Calendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        style={{ height: 500 }}
        views={["month", "week", "day", "agenda"]}
        defaultView="month"
        tooltipAccessor={(event) => `${event.title}${event.location ? `\n📍 ${event.location}` : ""}`}
      />
    </div>
  );
};

export default StudentCalendar;
